import Vue from "vue";
import VueRouter from "vue-router";
import Forms from "../views/Forms.vue";
import AdminPanel from "../views/AdminPanel.vue";
import Dashboard from "../views/Dashboard.vue";
import FoydaliQazilma from "../views/FoydaliQazilma.vue";
import Korrupsiya from "../views/Korrupsiya.vue";
import NeftGaz from "../views/NeftGaz.vue";
import Boshqalar from "../views/Boshqalar.vue";
import Login from '../views/Login.vue';
import Error from '../components/error.vue';
import Camera from '../views/Camera.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "qabul",
    component: Forms,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: {requiresAuth: true}
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminPanel,
    meta: {requiresAuth: true}
  },
  {
    path: "/foydali",
    name: "foydali",
    component: FoydaliQazilma,
    meta: {requiresAuth: true}
  },
  {
    path: "/korrupsiya",
    name: "korrupsiya",
    component: Korrupsiya,
    meta: {requiresAuth: true}
  },
  {
    path: "/neft-gaz",
    name: "neft-gaz",
    component: NeftGaz,
    meta: {requiresAuth: true}
  },
  {
    path: "/boshqalar",
    name: "boshqalar",
    component: Boshqalar,
    meta: {requiresAuth: true}
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/camera',
    name: 'Camera',
    component: Camera
  },
  {
    path: "*",
    name: 'error',
    component: Error
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const isLoggedIn = localStorage.getItem("userInfo");
    if (isLoggedIn) {
      next();
      return;
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;
